import React, { useCallback, useEffect, useState } from 'react';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import { useTranslation } from 'react-i18next';
import { Box, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useGetRelationsSelectQuery } from '../../../../../newapi/global/relation/relationSlice';
import ShValidatedInput from '../../../../theme/inputs/ShValidatedInput';
import ShValidatedInputDropdown from '../../../../theme/dropdowns/ShValidatedInputDropdown';
import { setTabErrors } from '../../../../../newapi/global/progressionTabSlice';
import * as yup from 'yup';
import ShDateRangePicker from '../../../../theme/ShDateRangePicker';
import Text from '../../../../theme/text/Text';
import { tokens } from '../../../../../theme';
import { ENV_TYPES } from '../../../Sidebar';
import ShSwitch from '../../../../theme/inputs/ShSwitch';
import EMGeneralExplainerBox from "../../../ModalsPopover/explainers/EMGeneralExplainerBox";

const Content = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const data = { ...props.data };
    const [loaded, setLoaded] = useState(false);
    const dispatch = useDispatch();
    const { data: relations, isLoading } = useGetRelationsSelectQuery();

    // Get values to determine if the relation dropdown should be shown
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];
    const selectedId = useSelector((state) => state.settings.environment.selectedId);

    const handleInput = (key, val) => {
        props.handleDataUpdate({ [key]: val, ...(key === "relationId" && { webshopCredentialsId: null }) });
        dispatch(setTabErrors({ ...props.errors, [key]: '' }));
    };

    const select = (date) => {
        const formattedDate = date[0].formattedStartDate;
        props.handleDataUpdate({ date_planned: formattedDate });
    }

    // Set virtual product is true for POST request
    useEffect(() => {
        if(loaded) {
            props.handleDataUpdate({ isVirtual: true });
        }
        setLoaded(true);
    }, [loaded]);

    return (
        <>
            <Box 
                sx={{
                    display:'flex',
                    flexDirection:"column",
                }}
            >
                {isFulfilment && !isRelation && (
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        paddingTop: 1.5,
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7,
                    }}
                >
                    
                    <Box
                        sx={{
                            width:140,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text>{t("relation")}</Text>
                    </Box>
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ShValidatedInputDropdown
                            key={data.relationId}
                            displayName={"name"} 
                            changeField={"id"}
                            valueKey={"id"}
                            closeOnSelection
                            searchOptions={{
                                enabled: true,
                                placeholder: t("search_relation_placeholder")
                            }}
                            styles={{
                                minWidth:300
                            }}

                            disallowDeselection
                            name="relationId"
                            selected={relations?.find(item => item.id === data.relationId)?.id ?? -1}
                            options={relations ? relations : []}
                            noSelection={t("choose_option")} 
                            onChange={handleInput}
                            error={props.errors.relationId}
                        />
                    </Box>
                </Box>
                )}
                <Box 
                    sx={{
                        width:1,
                        paddingTop: 1.5,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:140,
                        }}
                    >
                        <Text>{t("reference")}</Text>
                    </Box>
                        <Box
                            sx={{
                                flex:1,
                                borderRadius:4,
                                display:"flex",
                            }}
                        >
                        <ShValidatedInput
                            name="webshopreference"
                            value={data.webshopreference}
                            onChange={handleInput}
                            error={props.errors.webshopreference}
                        />
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        paddingTop: 1.5,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    
                    <Box
                        sx={{
                            width:140,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text>{t("date_planned")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ShDateRangePicker 
                            singleSelect={true} 
                            select={select} 
                            size={32}
                        >

                        </ShDateRangePicker>
                    </Box>
                    
                </Box>
                <Box 
                    sx={{
                        width:1,
                        paddingTop: 1.5,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    
                    <Box
                        sx={{
                            width:140,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text>{t("b2b_order")}</Text>
                        <EMGeneralExplainerBox title={t('em_b2b_title')} text={t('em_b2b_text')}/>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                    <ShSwitch
                        checked={data.isB2B ?? false}
                        onChange={(e) => handleInput('isB2B', e.target.checked)}
                    />
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:140,
                        }}
                    >
                        <Text>{t("remark")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            borderRadius:4,
                            paddingTop: 1.5,
                            display:"flex",
                        }}
                    >
                        <ShValidatedInput
                            name="remark"
                            value={data.remark}
                            onChange={handleInput}
                        />
                    </Box>
                </Box>
            </Box>
        </>
    );
};

const Details = (props) => {
    const {t} = useTranslation();
    const schema = yup.object({
        webshopreference: yup.string().min(5).max(35).required(t('webshopreference'))
    });
    
    return (
        <ProgressionTab
            tabId="details"
            subtitle={t("details")}
            step={1}
            maxSteps={3}
            nextTab="tabAddressDetails"
            schema={schema}
        >
            <Content {...props} />
        </ProgressionTab>
    );
};

export default Details; 